import { EntriesApi } from 'modules/entry/api';
import React, { useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { DropdownItemProps, Form } from 'semantic-ui-react';

const m = defineMessages({
  add: {
    id: 'ReferredByDropdown.Add',
    defaultMessage: 'Ajouter ',
  },
  noResult: {
    id: 'ReferredByDropdown.NoResult',
    defaultMessage: 'Aucune suggestion trouvée',
  },
  placeholder: {
    id: 'ReferredByDropdown.Placeholder',
    defaultMessage: 'Toutes les références',
  },
});

interface Props {
  onChange: (value: any[]) => void;
  value: any;
}

export const ReferredByDropdown: React.FC<Props> = ({ onChange, value }) => {
  const { formatMessage } = useIntl();

  const [options, setOptions] = useState<DropdownItemProps[]>([]);

  const currentValueOptions = useMemo(
    () =>
      value
        ? (value as string[]).map((v) => ({ key: v, text: v, value: v }))
        : [],
    [value]
  );

  useEffect(() => {
    setOptions(currentValueOptions);
  }, [currentValueOptions]);

  const handleAddItem = (newTextItem: any) => {
    setOptions((state) => [
      { key: newTextItem, text: newTextItem, value: newTextItem },
      ...state,
    ]);
  };

  const handleSearch = (searchQuery: string) => {
    if (searchQuery.length <= 1) return;

    EntriesApi.getReferredBySuggestion(searchQuery).then(
      (fetchedSuggestions) => {
        const fetchedSuggestionOptions = (fetchedSuggestions as string[]).map(
          (v) => ({
            key: v,
            text: v,
            value: v,
          })
        );

        setOptions([...fetchedSuggestionOptions, ...currentValueOptions]);
      }
    );
  };

  return (
    <Form.Dropdown
      selection
      onChange={(e, { value }) => onChange((value as any[]) ?? [])}
      multiple
      search
      allowAdditions
      onAddItem={(e, { value }) => handleAddItem(value)}
      options={options}
      onSearchChange={(e, { searchQuery }) => handleSearch(searchQuery)}
      value={value}
      noResultsMessage={formatMessage(m.noResult)}
      additionLabel={formatMessage(m.add)}
      placeholder={formatMessage(m.placeholder)}
    />
  );
};
